import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { CheckboxGroup } from '../ui/CheckboxGroup';
import { FileUpload } from '../ui/FileUpload';
import { MascotPanel } from '../ui/MascotPanel';
export function Step6Legal() {
  const {
    data,
    updateData
  } = useIntake();
  const legalDocOptions = [{
    value: 'algemene_voorwaarden',
    label: 'Algemene Voorwaarden'
  }, {
    value: 'privacyverklaring',
    label: 'Privacyverklaring'
  }, {
    value: 'cookiebeleid',
    label: 'Cookiebeleid'
  }, {
    value: 'disclaimer',
    label: 'Disclaimer'
  }, {
    value: 'retourbeleid',
    label: 'Retourbeleid'
  }, {
    value: 'garantiebeleid',
    label: 'Garantiebeleid'
  }, {
    value: 'klachtenprocedure',
    label: 'Klachtenprocedure'
  }, {
    value: 'leveringsvoorwaarden',
    label: 'Leveringsvoorwaarden'
  }, {
    value: 'verwerkersovereenkomst',
    label: 'Verwerkersovereenkomst'
  }, {
    value: 'servicevoorwaarden',
    label: 'Servicevoorwaarden / SLA'
  }, {
    value: 'overig',
    label: 'Overige documenten'
  }];
  const handleDocUpload = (docValue: string, url: string) => {
    updateData({
      legalDocs: {
        ...data.legalDocs,
        [docValue]: {
          file: url,
          text: '',
          status: 'uploaded'
        }
      }
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-386">
      <MascotPanel message="Een website moet niet alleen mooi zijn, maar ook juridisch kloppen. Heeft u al documenten zoals algemene voorwaarden of een privacyverklaring?" data-id="element-387" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-388">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-389">Juridische Zaken</h2>

        <div data-id="element-390">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-391">
            Zijn er juridische documenten die op de website moeten komen?
          </label>
          <RadioGroup columns={1} value={data.hasLegalDocs} onChange={val => updateData({
          hasLegalDocs: val
        })} options={[{
          value: 'yes',
          label: 'Ja, ik heb deze documenten al'
        }, {
          value: 'no',
          label: 'Nee, ik moet deze nog (laten) opstellen'
        }]} data-id="element-392" />
        </div>

        <AnimatePresence data-id="element-393">
          {data.hasLegalDocs === 'yes' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 overflow-hidden pt-4 border-t border-gray-100" data-id="element-394">
              <div data-id="element-395">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-396">
                  Welke documenten heeft u beschikbaar?
                </label>
                <CheckboxGroup columns={2} options={legalDocOptions} values={data.legalDocsList} onChange={vals => updateData({
              legalDocsList: vals
            })} data-id="element-397" />
              </div>

              {data.legalDocsList.length > 0 && <div className="space-y-6 mt-6" data-id="element-398">
                  <h3 className="font-semibold text-gray-900" data-id="element-399">
                    Upload uw documenten
                  </h3>
                  {data.legalDocsList.map(docValue => {
              const docLabel = legalDocOptions.find(o => o.value === docValue)?.label;
              return <div key={docValue} className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-400">
                        <FileUpload label={docLabel} accept=".pdf,.doc,.docx" value={data.legalDocs[docValue]?.file} onChange={url => handleDocUpload(docValue, url)} data-id="element-401" />
                      </div>;
            })}
                </div>}
            </motion.div>}

          {data.hasLegalDocs === 'no' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 overflow-hidden pt-4 border-t border-gray-100" data-id="element-402">
              <div data-id="element-403">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-404">
                  Hoe wilt u dit aanpakken?
                </label>
                <RadioGroup columns={1} value={data.legalDocsApproach} onChange={val => updateData({
              legalDocsApproach: val
            })} options={[{
              value: 'noord',
              label: 'Noord Digital helpt mij hierbij',
              description: 'Wij zorgen voor juridisch correcte documenten'
            }, {
              value: 'advisor',
              label: 'Ik schakel zelf een juridisch adviseur in'
            }, {
              value: 'self',
              label: 'Ik stel ze zelf op'
            }]} data-id="element-405" />
              </div>

              <div data-id="element-406">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-407">
                  Welke documenten heeft u nodig?
                </label>
                <CheckboxGroup columns={2} options={legalDocOptions} values={data.legalDocsNeeded} onChange={vals => updateData({
              legalDocsNeeded: vals
            })} data-id="element-408" />
              </div>
            </motion.div>}
        </AnimatePresence>

        <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-409">
          <h3 className="font-semibold text-gray-900 mb-4" data-id="element-410">
            Welke documenten zijn vaak nodig?
          </h3>
          <ul className="space-y-3 text-sm text-gray-700" data-id="element-411">
            <li className="flex items-start" data-id="element-412">
              <span className="text-[#007AFF] mr-2" data-id="element-413">•</span>
              <span data-id="element-414">
                <strong data-id="element-415">Privacyverklaring:</strong> Verplicht als u een
                contactformulier heeft of analytics gebruikt.
              </span>
            </li>
            <li className="flex items-start" data-id="element-416">
              <span className="text-[#007AFF] mr-2" data-id="element-417">•</span>
              <span data-id="element-418">
                <strong data-id="element-419">Cookiebeleid:</strong> Verplicht bij gebruik van
                tracking cookies.
              </span>
            </li>
            <li className="flex items-start" data-id="element-420">
              <span className="text-[#007AFF] mr-2" data-id="element-421">•</span>
              <span data-id="element-422">
                <strong data-id="element-423">Algemene Voorwaarden:</strong> Sterk aanbevolen voor uw
                dienstverlening.
              </span>
            </li>
            <li className="flex items-start" data-id="element-424">
              <span className="text-[#007AFF] mr-2" data-id="element-425">•</span>
              <span data-id="element-426">
                <strong data-id="element-427">Disclaimer:</strong> Beschermt u tegen aansprakelijkheid
                voor informatie op de website.
              </span>
            </li>
            <li className="flex items-start" data-id="element-428">
              <span className="text-[#007AFF] mr-2" data-id="element-429">•</span>
              <span data-id="element-430">
                <strong data-id="element-431">Retourbeleid:</strong> Verplicht voor webshops
                (herroepingsrecht).
              </span>
            </li>
            <li className="flex items-start" data-id="element-432">
              <span className="text-[#007AFF] mr-2" data-id="element-433">•</span>
              <span data-id="element-434">
                <strong data-id="element-435">Garantiebeleid:</strong> Aanbevolen als u producten
                verkoopt.
              </span>
            </li>
            <li className="flex items-start" data-id="element-436">
              <span className="text-[#007AFF] mr-2" data-id="element-437">•</span>
              <span data-id="element-438">
                <strong data-id="element-439">Klachtenprocedure:</strong> Verplicht voor bepaalde
                branches (bijv. zorg, financieel).
              </span>
            </li>
            <li className="flex items-start" data-id="element-440">
              <span className="text-[#007AFF] mr-2" data-id="element-441">•</span>
              <span data-id="element-442">
                <strong data-id="element-443">Leveringsvoorwaarden:</strong> Belangrijk bij fysieke
                producten of diensten met levertijden.
              </span>
            </li>
            <li className="flex items-start" data-id="element-444">
              <span className="text-[#007AFF] mr-2" data-id="element-445">•</span>
              <span data-id="element-446">
                <strong data-id="element-447">Verwerkersovereenkomst:</strong> Nodig als u
                persoonsgegevens deelt met derden.
              </span>
            </li>
            <li className="flex items-start" data-id="element-448">
              <span className="text-[#007AFF] mr-2" data-id="element-449">•</span>
              <span data-id="element-450">
                <strong data-id="element-451">Servicevoorwaarden / SLA:</strong> Voor bedrijven die
                doorlopende diensten leveren.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </motion.div>;
}